import { useNavigate } from "@tanstack/react-router";
import { PageHeader } from "@/components/PageHeader";
import { Checkout } from "./Checkout";

/** Settings › Subscription › Subscribe: the checkout inside the app, for a company on its trial (suite ADR-0097). */
export function CheckoutPage() {
  const navigate = useNavigate();
  const back = () => void navigate({ to: "/settings/subscription" });
  return (
    <div className="flex flex-col gap-4">
      <PageHeader title="Subscribe" />
      <Checkout onDone={back} onCancel={back} />
    </div>
  );
}
